import { render, staticRenderFns } from "./XDevBtns.vue?vue&type=template&id=5fba41ba&scoped=true"
import script from "./XDevBtns.vue?vue&type=script&lang=js"
export * from "./XDevBtns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fba41ba",
  null
  
)

export default component.exports